import { settingsModuleQuery, useModule } from 'system/structure-modules';

export default function SettingsIndexScreen() {
    const { SettingsScreen } = useModule(settingsModuleQuery);
    return <SettingsScreen />;
}
